// Mock Data for Village Marhana Website

export const villageInfo = {
  name: { en: "Marhana", pa: "ਮਰਹਾਣਾ" },
  tagline: { 
    en: "A Historic Village of Punjab", 
    pa: "ਪੰਜਾਬ ਦਾ ਇੱਕ ਇਤਿਹਾਸਕ ਪਿੰਡ" 
  },
  district: { en: "Tarn Taran", pa: "ਤਰਨ ਤਾਰਨ" },
  state: { en: "Punjab", pa: "ਪੰਜਾਬ" },
  tehsil: { en: "Tarn Taran", pa: "ਤਰਨ ਤਾਰਨ" },
  pincode: "143410",
  area: "725 hectares",
  nearestTown: { en: "Patti", pa: "ਪੱਟੀ" },
  distanceFromDistrict: "30 km",
  coordinates: { lat: 31.45, lng: 74.92 },
  villageCode: "038000"
};

export const demographics = {
  totalPopulation: 3481,
  male: 1854,
  female: 1627,
  sexRatio: 877,
  households: 585,
  childPopulation: 401,
  childMale: 235,
  childFemale: 166,
  scheduledCastes: 1279,
  literatePopulation: 2148,
  illiteratePopulation: 1333,
  literacyRate: 61.71,
  maleLiteracy: 67.37,
  femaleLiteracy: 55.26
};

export const pattis = [
  { id: 1, name: { en: "Toge ki Patti", pa: "ਟੋਗੇ ਕੀ ਪੱਟੀ" } },
  { id: 2, name: { en: "Samse ki Patti", pa: "ਸਮਸੇ ਕੀ ਪੱਟੀ" } },
  { id: 3, name: { en: "Sidhane ki Patti", pa: "ਸਿਧਾਣੇ ਕੀ ਪੱਟੀ" } },
  { id: 4, name: { en: "Lal ki Patti", pa: "ਲਾਲ ਕੀ ਪੱਟੀ" } },
  { id: 5, name: { en: "Mokal ki Patti", pa: "ਮੋਕਲ ਕੀ ਪੱਟੀ" } },
  { id: 6, name: { en: "Vehda", pa: "ਵੇਹੜਾ" } },
  { id: 7, name: { en: "Karnauli", pa: "ਕਰਨੌਲੀ" } }
];

export const directoryEntries = [
  { id: 1, name: "Gurpreet Singh", phone: "+91 98765 43210", pattiId: 1, occupation: "Farmer" },
  { id: 2, name: "Harjinder Kaur", phone: "+91 98765 43211", pattiId: 1, occupation: "Teacher" },
  { id: 3, name: "Balwinder Singh", phone: "+91 98765 43212", pattiId: 2, occupation: "Shopkeeper" },
  { id: 4, name: "Manpreet Kaur", phone: "+91 98765 43213", pattiId: 2, occupation: "Nurse" },
  { id: 5, name: "Sukhwinder Singh", phone: "+91 98765 43214", pattiId: 3, occupation: "Farmer" },
  { id: 6, name: "Paramjit Kaur", phone: "+91 98765 43215", pattiId: 3, occupation: "Homemaker" },
  { id: 7, name: "Jaswant Singh", phone: "+91 98765 43216", pattiId: 4, occupation: "Driver" },
  { id: 8, name: "Kulwinder Kaur", phone: "+91 98765 43217", pattiId: 4, occupation: "Anganwadi Worker" },
  { id: 9, name: "Rajwinder Singh", phone: "+91 98765 43218", pattiId: 5, occupation: "Businessman" },
  { id: 10, name: "Simranjit Kaur", phone: "+91 98765 43219", pattiId: 5, occupation: "Student" }
];

export const heroes = [
  {
    id: 1,
    name: { en: "Shaheed Kehar Singh", pa: "ਸ਼ਹੀਦ ਕੇਹਰ ਸਿੰਘ" },
    image: "https://customer-assets.emergentagent.com/job_f7a4ef67-320e-40c2-bbb7-b665ce2e1eaa/artifacts/t79cy6c4_image.png",
    year: "1918",
    title: { en: "Freedom Fighter - Kala Pani", pa: "ਆਜ਼ਾਦੀ ਘੁਲਾਟੀਏ - ਕਾਲਾ ਪਾਣੀ" },
    description: {
      en: "A young revolutionary who was sentenced to Kala Pani (Andaman jail) at just 20 years of age. He sacrificed his life for India's freedom, dying due to inhuman torture in the Andaman jail in 1918.",
      pa: "ਇੱਕ ਨੌਜਵਾਨ ਇਨਕਲਾਬੀ ਜਿਸਨੂੰ ਸਿਰਫ਼ 20 ਸਾਲ ਦੀ ਉਮਰ ਵਿੱਚ ਕਾਲਾ ਪਾਣੀ (ਅੰਡੇਮਾਨ ਜੇਲ੍ਹ) ਦੀ ਸਜ਼ਾ ਦਿੱਤੀ ਗਈ। ਉਨ੍ਹਾਂ ਨੇ 1918 ਵਿੱਚ ਅੰਡੇਮਾਨ ਜੇਲ੍ਹ ਵਿੱਚ ਗੈਰ-ਮਨੁੱਖੀ ਤਸੀਹਿਆਂ ਕਾਰਨ ਸ਼ਹੀਦੀ ਪ੍ਰਾਪਤ ਕੀਤੀ।"
    }
  },
  {
    id: 2,
    name: { en: "Baba Ishar Singh Ji Marhana", pa: "ਬਾਬਾ ਈਸ਼ਰ ਸਿੰਘ ਜੀ ਮਰਹਾਣਾ" },
    image: "https://customer-assets.emergentagent.com/job_f7a4ef67-320e-40c2-bbb7-b665ce2e1eaa/artifacts/aph6i1o6_image.png",
    year: "1878-1941",
    title: { en: "Ex-President Sri Darbar Sahib, Amritsar", pa: "ਸਾਬਕਾ ਪ੍ਰਧਾਨ ਸ੍ਰੀ ਦਰਬਾਰ ਸਾਹਿਬ, ਅੰਮ੍ਰਿਤਸਰ" },
    description: {
      en: "Born on January 1, 1878, Baba Ishar Singh was an Akali activist and Ghadri revolutionary. He traveled to California in 1908 and became part of the famous Ghadar Party. He served as President of Sri Darbar Sahib Prabhandak Committee until his death on August 16, 1941.",
      pa: "1 ਜਨਵਰੀ 1878 ਨੂੰ ਜਨਮੇ, ਬਾਬਾ ਈਸ਼ਰ ਸਿੰਘ ਜੀ ਅਕਾਲੀ ਕਾਰਕੁਨ ਅਤੇ ਗ਼ਦਰੀ ਇਨਕਲਾਬੀ ਸਨ। ਉਹ 1908 ਵਿੱਚ ਕੈਲੀਫੋਰਨੀਆ ਗਏ ਅਤੇ ਮਸ਼ਹੂਰ ਗ਼ਦਰ ਪਾਰਟੀ ਦਾ ਹਿੱਸਾ ਬਣੇ। ਉਨ੍ਹਾਂ ਨੇ 16 ਅਗਸਤ 1941 ਤੱਕ ਸ੍ਰੀ ਦਰਬਾਰ ਸਾਹਿਬ ਪ੍ਰਬੰਧਕ ਕਮੇਟੀ ਦੇ ਪ੍ਰਧਾਨ ਵਜੋਂ ਸੇਵਾ ਕੀਤੀ।"
    }
  }
];

export const localServices = [
  // Schools
  { id: 1, name: { en: "Baba Isher Singh Govt. Sr. Sec. School Marhana", pa: "ਬਾਬਾ ਈਸ਼ਰ ਸਿੰਘ ਸਰਕਾਰੀ ਸੀਨੀਅਰ ਸੈਕੰਡਰੀ ਸਕੂਲ ਮਰਹਾਣਾ" }, type: "school", phone: "" },
  { id: 2, name: { en: "Shri Guru Harkrishan Public School, Burj Marhana", pa: "ਸ਼੍ਰੀ ਗੁਰੂ ਹਰਿਕ੍ਰਿਸ਼ਨ ਪਬਲਿਕ ਸਕੂਲ, ਬੁਰਜ ਮਰਹਾਣਾ" }, type: "school", phone: "" },
  
  // Gurudwaras
  { id: 3, name: { en: "Gurudwara Baba Bir Singh Marhana", pa: "ਗੁਰਦੁਆਰਾ ਬਾਬਾ ਬੀਰ ਸਿੰਘ ਮਰਹਾਣਾ" }, type: "religious", phone: "+91 99150 89990", details: { en: "Committee Head: Dharamjit Singh", pa: "ਕਮੇਟੀ ਮੁਖੀ: ਧਰਮਜੀਤ ਸਿੰਘ" } },
  { id: 4, name: { en: "Gurudwara Baba Ratan Dev Ji, Marhana", pa: "ਗੁਰਦੁਆਰਾ ਬਾਬਾ ਰਤਨ ਦੇਵ ਜੀ, ਮਰਹਾਣਾ" }, type: "religious", phone: "+91 98031 60435", details: { en: "Granthi: Baba Joga Singh", pa: "ਗ੍ਰੰਥੀ: ਬਾਬਾ ਜੋਗਾ ਸਿੰਘ" } },
  
  // Healthcare
  { id: 5, name: { en: "Dr. Sarabjit Singh", pa: "ਡਾ. ਸਰਬਜੀਤ ਸਿੰਘ" }, type: "hospital", phone: "+91 82839 63558" },
  { id: 6, name: { en: "Tur Medical Store", pa: "ਤੂਰ ਮੈਡੀਕਲ ਸਟੋਰ" }, type: "shop", phone: "+91 94174 89839" },
  
  // Government
  { id: 7, name: { en: "Police Station Chohla Sahib", pa: "ਪੁਲਿਸ ਸਟੇਸ਼ਨ ਚੋਹਲਾ ਸਾਹਿਬ" }, type: "government", phone: "" },
  { id: 8, name: { en: "Post Office", pa: "ਡਾਕਘਰ" }, type: "government", phone: "" },
  
  // NGO
  { id: 9, name: { en: "Baba Ratan Dev Sewa Society, Marhana", pa: "ਬਾਬਾ ਰਤਨ ਦੇਵ ਸੇਵਾ ਸੁਸਾਇਟੀ, ਮਰਹਾਣਾ" }, type: "ngo", phone: "+91 75022 97777", details: { en: "Head: Baba Jaggi", pa: "ਮੁਖੀ: ਬਾਬਾ ਜੱਗੀ" } }
];

// Important Village Contacts
export const importantContacts = [
  { id: 1, title: { en: "Sarpanch", pa: "ਸਰਪੰਚ" }, name: "Adv. Hira Singh", phone: "+91 94785 00007" },
  { id: 2, title: { en: "Nambardar", pa: "ਨੰਬਰਦਾਰ" }, name: "Hardeep Singh", phone: "+91 98760 30541" },
  { id: 3, title: { en: "Nambardar", pa: "ਨੰਬਰਦਾਰ" }, name: "Gurwinder Singh", phone: "+91 97790 20947" },
  { id: 4, title: { en: "Patwari", pa: "ਪਟਵਾਰੀ" }, name: "Gursahib Singh", phone: "+91 98589 01313" }
];

// Website Admin Contact
export const adminContact = {
  name: "Sukhjeet Singh Gill",
  phone: "+91 97802 21874",
  role: { en: "Website Admin", pa: "ਵੈੱਬਸਾਈਟ ਐਡਮਿਨ" }
};

export const newsAnnouncements = [
  {
    id: 1,
    title: { en: "Panchayat Meeting Scheduled", pa: "ਪੰਚਾਇਤ ਮੀਟਿੰਗ ਤਹਿ" },
    content: { 
      en: "Monthly panchayat meeting will be held on 15th August at Gurudwara Sahib. All villagers are requested to attend.",
      pa: "ਮਹੀਨਾਵਾਰ ਪੰਚਾਇਤ ਮੀਟਿੰਗ 15 ਅਗਸਤ ਨੂੰ ਗੁਰਦੁਆਰਾ ਸਾਹਿਬ ਵਿਖੇ ਹੋਵੇਗੀ। ਸਾਰੇ ਪਿੰਡ ਵਾਸੀਆਂ ਨੂੰ ਹਾਜ਼ਰ ਹੋਣ ਦੀ ਬੇਨਤੀ ਹੈ।"
    },
    date: "2025-08-10",
    type: "announcement"
  },
  {
    id: 2,
    title: { en: "Road Construction Update", pa: "ਸੜਕ ਨਿਰਮਾਣ ਅੱਪਡੇਟ" },
    content: { 
      en: "New road construction from Marhana to Patti has been approved. Work will begin next month.",
      pa: "ਮਰਹਾਣਾ ਤੋਂ ਪੱਟੀ ਤੱਕ ਨਵੀਂ ਸੜਕ ਦੀ ਉਸਾਰੀ ਮਨਜ਼ੂਰ ਹੋ ਗਈ ਹੈ। ਕੰਮ ਅਗਲੇ ਮਹੀਨੇ ਸ਼ੁਰੂ ਹੋਵੇਗਾ।"
    },
    date: "2025-08-05",
    type: "news"
  },
  {
    id: 3,
    title: { en: "Vaccination Camp", pa: "ਟੀਕਾਕਰਨ ਕੈਂਪ" },
    content: { 
      en: "Free vaccination camp for children will be organized at PHC on 20th August.",
      pa: "ਬੱਚਿਆਂ ਲਈ ਮੁਫ਼ਤ ਟੀਕਾਕਰਨ ਕੈਂਪ 20 ਅਗਸਤ ਨੂੰ PHC ਵਿਖੇ ਲਗਾਇਆ ਜਾਵੇਗਾ।"
    },
    date: "2025-08-03",
    type: "health"
  }
];

export const events = [
  {
    id: 1,
    title: { en: "Independence Day Celebration", pa: "ਸੁਤੰਤਰਤਾ ਦਿਵਸ ਸਮਾਰੋਹ" },
    date: "2025-08-15",
    time: "08:00 AM",
    location: { en: "Government School Ground", pa: "ਸਰਕਾਰੀ ਸਕੂਲ ਮੈਦਾਨ" },
    description: { en: "Flag hoisting ceremony followed by cultural programs", pa: "ਝੰਡਾ ਲਹਿਰਾਉਣ ਦੀ ਰਸਮ ਅਤੇ ਸੱਭਿਆਚਾਰਕ ਪ੍ਰੋਗਰਾਮ" }
  },
  {
    id: 2,
    title: { en: "Baisakhi Mela", pa: "ਵਿਸਾਖੀ ਮੇਲਾ" },
    date: "2026-04-14",
    time: "10:00 AM",
    location: { en: "Village Ground", pa: "ਪਿੰਡ ਦਾ ਮੈਦਾਨ" },
    description: { en: "Traditional Baisakhi celebrations with Bhangra and Gidda", pa: "ਭੰਗੜਾ ਅਤੇ ਗਿੱਧਾ ਨਾਲ ਰਵਾਇਤੀ ਵਿਸਾਖੀ ਜਸ਼ਨ" }
  },
  {
    id: 3,
    title: { en: "Guru Nanak Dev Ji Gurpurab", pa: "ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ ਗੁਰਪੁਰਬ" },
    date: "2025-11-15",
    time: "04:00 AM",
    location: { en: "Gurudwara Sahib", pa: "ਗੁਰਦੁਆਰਾ ਸਾਹਿਬ" },
    description: { en: "Akhand Path and Langar Seva", pa: "ਅਖੰਡ ਪਾਠ ਅਤੇ ਲੰਗਰ ਸੇਵਾ" }
  }
];

export const galleryImages = [
  { id: 1, url: "https://images.unsplash.com/photo-1514222134-b57cbb8ce073?w=800", caption: { en: "Wheat Fields of Marhana", pa: "ਮਰਹਾਣਾ ਦੇ ਕਣਕ ਦੇ ਖੇਤ" } },
  { id: 2, url: "https://images.unsplash.com/photo-1609946860441-a51ffcf22208?w=800", caption: { en: "Village Life", pa: "ਪਿੰਡ ਦੀ ਜ਼ਿੰਦਗੀ" } },
  { id: 3, url: "https://images.unsplash.com/photo-1590059390047-f5e617a5eb7d?w=800", caption: { en: "Gurudwara Sahib", pa: "ਗੁਰਦੁਆਰਾ ਸਾਹਿਬ" } },
  { id: 4, url: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800", caption: { en: "Farmers at Work", pa: "ਕੰਮ 'ਤੇ ਕਿਸਾਨ" } },
  { id: 5, url: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800", caption: { en: "Sunset in Marhana", pa: "ਮਰਹਾਣਾ ਵਿੱਚ ਸੂਰਜ ਡੁੱਬਣਾ" } },
  { id: 6, url: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=800", caption: { en: "Green Fields", pa: "ਹਰੇ ਖੇਤ" } }
];

export const agricultureInfo = {
  majorCrops: [
    { en: "Wheat", pa: "ਕਣਕ" },
    { en: "Rice", pa: "ਚਾਵਲ" },
    { en: "Sugarcane", pa: "ਗੰਨਾ" },
    { en: "Cotton", pa: "ਕਪਾਹ" }
  ],
  cropPrices: [
    { crop: { en: "Wheat", pa: "ਕਣਕ" }, price: "₹2,275/quintal", trend: "up" },
    { crop: { en: "Rice", pa: "ਚਾਵਲ" }, price: "₹2,203/quintal", trend: "stable" },
    { crop: { en: "Sugarcane", pa: "ਗੰਨਾ" }, price: "₹350/quintal", trend: "up" },
    { crop: { en: "Cotton", pa: "ਕਪਾਹ" }, price: "₹6,620/quintal", trend: "down" }
  ],
  weather: {
    temperature: "32°C",
    humidity: "65%",
    condition: { en: "Partly Cloudy", pa: "ਅੰਸ਼ਕ ਬੱਦਲਵਾਈ" },
    forecast: { en: "Rain expected in 2 days", pa: "2 ਦਿਨਾਂ ਵਿੱਚ ਮੀਂਹ ਦੀ ਸੰਭਾਵਨਾ" }
  }
};

export const nearbyVillages = [
  "Dhun", "Chamba Kalan", "Kambo Dhaiwala", "Kiriyan", "Jauneke",
  "Gandiwind", "Ruriwala", "Nathupur", "Dhattal", "Dedehar Sahib", "Sarhali Kalan"
];

export const connectivity = {
  publicBus: { en: "Available within 5 km", pa: "5 ਕਿਲੋਮੀਟਰ ਦੇ ਅੰਦਰ ਉਪਲਬਧ" },
  privateBus: { en: "Available within 5 km", pa: "5 ਕਿਲੋਮੀਟਰ ਦੇ ਅੰਦਰ ਉਪਲਬਧ" },
  railway: { en: "Available within 5 km", pa: "5 ਕਿਲੋਮੀਟਰ ਦੇ ਅੰਦਰ ਉਪਲਬਧ" }
};

export const translations = {
  en: {
    home: "Home",
    about: "About",
    directory: "Directory",
    services: "Services",
    news: "News",
    gallery: "Gallery",
    events: "Events",
    agriculture: "Agriculture",
    contact: "Contact",
    grievance: "Grievance",
    language: "Language",
    population: "Population",
    households: "Households",
    area: "Area",
    literacyRate: "Literacy Rate",
    searchDirectory: "Search Directory...",
    selectPatti: "Select Patti",
    allPattis: "All Pattis",
    phone: "Phone",
    occupation: "Occupation",
    submitGrievance: "Submit Grievance",
    yourName: "Your Name",
    yourPhone: "Your Phone",
    subject: "Subject",
    message: "Message",
    submit: "Submit",
    heroes: "Our Heroes",
    demographics: "Demographics",
    connectivity: "Connectivity",
    nearbyVillages: "Nearby Villages",
    cropPrices: "Crop Prices",
    weather: "Weather",
    upcomingEvents: "Upcoming Events",
    latestNews: "Latest News",
    viewAll: "View All",
    male: "Male",
    female: "Female",
    scheduledCastes: "Scheduled Castes",
    sexRatio: "Sex Ratio",
    welcomeTo: "Welcome to",
    villageOf: "Village of",
    discoverRich: "Discover the rich heritage, vibrant community, and timeless traditions of our beloved village."
  },
  pa: {
    home: "ਮੁੱਖ ਪੰਨਾ",
    about: "ਜਾਣਕਾਰੀ",
    directory: "ਡਾਇਰੈਕਟਰੀ",
    services: "ਸੇਵਾਵਾਂ",
    news: "ਖ਼ਬਰਾਂ",
    gallery: "ਗੈਲਰੀ",
    events: "ਸਮਾਗਮ",
    agriculture: "ਖੇਤੀਬਾੜੀ",
    contact: "ਸੰਪਰਕ",
    grievance: "ਸ਼ਿਕਾਇਤ",
    language: "ਭਾਸ਼ਾ",
    population: "ਆਬਾਦੀ",
    households: "ਘਰ",
    area: "ਖੇਤਰ",
    literacyRate: "ਸਾਖਰਤਾ ਦਰ",
    searchDirectory: "ਡਾਇਰੈਕਟਰੀ ਖੋਜੋ...",
    selectPatti: "ਪੱਟੀ ਚੁਣੋ",
    allPattis: "ਸਾਰੀਆਂ ਪੱਟੀਆਂ",
    phone: "ਫ਼ੋਨ",
    occupation: "ਕਿੱਤਾ",
    submitGrievance: "ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰੋ",
    yourName: "ਤੁਹਾਡਾ ਨਾਮ",
    yourPhone: "ਤੁਹਾਡਾ ਫ਼ੋਨ",
    subject: "ਵਿਸ਼ਾ",
    message: "ਸੁਨੇਹਾ",
    submit: "ਭੇਜੋ",
    heroes: "ਸਾਡੇ ਨਾਇਕ",
    demographics: "ਜਨਸੰਖਿਆ",
    connectivity: "ਆਵਾਜਾਈ",
    nearbyVillages: "ਨੇੜਲੇ ਪਿੰਡ",
    cropPrices: "ਫ਼ਸਲਾਂ ਦੇ ਭਾਅ",
    weather: "ਮੌਸਮ",
    upcomingEvents: "ਆਉਣ ਵਾਲੇ ਸਮਾਗਮ",
    latestNews: "ਤਾਜ਼ਾ ਖ਼ਬਰਾਂ",
    viewAll: "ਸਭ ਦੇਖੋ",
    male: "ਮਰਦ",
    female: "ਔਰਤ",
    scheduledCastes: "ਅਨੁਸੂਚਿਤ ਜਾਤੀਆਂ",
    sexRatio: "ਲਿੰਗ ਅਨੁਪਾਤ",
    welcomeTo: "ਜੀ ਆਇਆਂ ਨੂੰ",
    villageOf: "ਪਿੰਡ",
    discoverRich: "ਸਾਡੇ ਪਿਆਰੇ ਪਿੰਡ ਦੀ ਅਮੀਰ ਵਿਰਾਸਤ, ਜੀਵੰਤ ਭਾਈਚਾਰੇ ਅਤੇ ਸਦੀਵੀ ਪਰੰਪਰਾਵਾਂ ਦੀ ਖੋਜ ਕਰੋ।"
  }
};
